import { useEffect, useState } from "react";
import BigButton from "../common/BigButton";
import ListSettingView from "../common/ListSettingView";
import styles from "./VoiceSettingScreen.module.css";
import { useTranslation } from "react-i18next";
import {
  EnglishPronunciation,
  VoiceGender,
  getEnglishPronunciationString,
  getGenderString,
} from "./voice";
import {
  getEnglishPronunciationFromLocalStorage,
  getVoiceGenderFromLocalStroage,
  setEnglishPronunciationToLocalStorage,
  setVoiceGenderToLocalStroage,
} from "../settings/voiceSettings";
import BasicMenu from "../common/BasicMenu";

interface VoiceSettingScreenProps {
  open: boolean;
  handleOnUpdateValue?: () => void;
  handleOnClose?: () => void;
}

export default function VoiceSettingScreen(props: VoiceSettingScreenProps) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [gender, setGender] = useState<string>("");
  const [pronunciation, setPronunciation] = useState<string>("");

  const [openGenderSelectMenu, setOpenGenderSelectMenu] = useState(false);
  const [openPronunciationSelectMenu, setOpenPronunciationSelectMenu] =
    useState(false);

  useEffect(() => {
    updateGender();
    updatePronunciation();
  }, [props.open]);

  function updateGender() {
    const genderString = getGenderString(getVoiceGenderFromLocalStroage());
    setGender(genderString);
  }

  function updatePronunciation() {
    const pronunciationString = getEnglishPronunciationString(
      getEnglishPronunciationFromLocalStorage()
    );
    setPronunciation(pronunciationString);
  }

  async function updateGenderValue(gender: VoiceGender) {
    setOpenGenderSelectMenu(false);

    setVoiceGenderToLocalStroage(gender);

    updateGender();

    if (props.handleOnUpdateValue !== undefined) {
      props.handleOnUpdateValue();
    }
  }

  async function updatePronunciationValue(pronunciation: EnglishPronunciation) {
    setOpenPronunciationSelectMenu(false);

    setEnglishPronunciationToLocalStorage(pronunciation);

    updatePronunciation();

    if (props.handleOnUpdateValue !== undefined) {
      props.handleOnUpdateValue();
    }
  }

  function onClickGender(event: React.MouseEvent<HTMLDivElement>) {
    setAnchorEl(event.currentTarget);
    setOpenGenderSelectMenu(true);
  }

  function onClickPronunciation(event: React.MouseEvent<HTMLDivElement>) {
    setAnchorEl(event.currentTarget);
    setOpenPronunciationSelectMenu(true);
  }

  if (props.open === true) {
    return (
      <>
        <div className={styles.stack}>
          <div className={styles.container}>
            <div className={styles.contentContainer}>
              <span className={styles.titleText}>{t("voicesettings")}</span>
              <div className={styles.settingItemContainer}>
                <ListSettingView
                  title={t("voicegender")}
                  value={gender}
                  handleOnClick={onClickGender}
                />
                <ListSettingView
                  title={t("voiceustouk")}
                  value={pronunciation}
                  handleOnClick={onClickPronunciation}
                />
              </div>
              <div className={styles.bottomButtonContainer}>
                <BigButton
                  title={t("CloseButton")}
                  style="disable"
                  handleClick={() => {
                    if (props.handleOnClose !== undefined) {
                      props.handleOnClose();
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <BasicMenu
            isOpen={openGenderSelectMenu}
            anchorEl={anchorEl}
            buttons={[
              {
                title: t("male"),
                handleOnClose: () => {
                  updateGenderValue(VoiceGender.male);
                },
              },
              {
                title: t("female"),
                handleOnClose: () => {
                  updateGenderValue(VoiceGender.female);
                },
              },
            ]}
            handleOnClose={() => {
              setOpenGenderSelectMenu(false);
            }}
          />
          <BasicMenu
            isOpen={openPronunciationSelectMenu}
            anchorEl={anchorEl}
            buttons={[
              {
                title: t("american"),
                handleOnClose: () => {
                  updatePronunciationValue(EnglishPronunciation.america);
                },
              },
              {
                title: t("english"),
                handleOnClose: () => {
                  updatePronunciationValue(EnglishPronunciation.england);
                },
              },
              {
                title: t("australia"),
                handleOnClose: () => {
                  updatePronunciationValue(EnglishPronunciation.australia);
                },
              },
            ]}
            handleOnClose={() => {
              setOpenPronunciationSelectMenu(false);
            }}
          />
        </div>
      </>
    );
  } else {
    return null;
  }
}
